module.exports = __webpack_public_path__ + "img/fifth2.695e25ab.png";